import React from 'react';
import Link from '@material-ui/core/Link';
import Icon from '@material-ui/core/Icon';
import clsx from 'clsx';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { loadSdk } from '../../../core/Social/FbButton';
import { FACEBOOK_BASE } from '../../../core/styles/variables';

const useStyles = makeStyles((theme) => ({
  link: {
    cursor: 'pointer',
  },
  facebook: {
    color: FACEBOOK_BASE,
    backgroundColor: 'white',
    borderRadius: '50%',
  },
}));

const FacebookButton = ({ url }) => {
  const classes = useStyles();

  React.useEffect(() => {
    loadSdk();
  }, []);

  const handleClick = () => {
    window.FB?.ui?.(
      {
        display: 'popup',
        method: 'share',
        href: url,
      },
      function (response) {},
    );
  };

  return (
    <Link
      target="_blank"
      rel="noreferrer"
      onClick={handleClick}
      classes={{ root: classes.link }}
    >
      <Icon className={clsx('fab fa-facebook', classes.facebook)} />
    </Link>
  );
};

export default FacebookButton;
